export default "__VITE_ASSET__Ipa_FMQK__"